import Select from 'react-select'
import clsx from 'clsx'
import React from 'react'

const PageSizeSelect = ({value, onChange, className = ''}) => {
  const options = [{
    value: 2,
    label: '2 / Page'
  }, {
    value: 10,
    label: '10 / Page'
  }, {
    value: 30,
    label: '30 / Page'
  }, {
    value: 50,
    label: '50 / Page'
  }, {
    value: 100,
    label: '100 / Page'
  }]

  return (
    <Select
      name='PageSizeSelect'
      options={options}
      onChange={onChange}
      value={options.find(option => option.value === value)} // Set the initial selected value
      className={clsx(
        className
      )}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      menuPortalTarget={document.body}
      menuShouldScrollIntoView={false}
    />
  );
}

export default PageSizeSelect